<template>
    <div>
        <v-btn icon @click="showFilter">
            <v-icon>mdi-filter-outline</v-icon>
        </v-btn>

        <filter-coach-dialog ref="filter"/>
    </div>
</template>

<script>

import FilterCoachDialog from '@/components/student/FilterCoachDialog'

export default {
    components: {
        FilterCoachDialog
    },
    methods: {
        showFilter() {
            const vm = this
            vm.$refs.filter.show()
        }
    },
}
</script>